import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paginatorFilter'
})
export class PaginatorFilterPipe implements PipeTransform {

  transform(values: any[], actualPage: number): any[] {

    let filteredValues = [];
    let start = (actualPage - 1) * 7;
    let end = actualPage * 7;
    filteredValues = values.slice(start, end);
    return filteredValues;
  }

}
